var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreditCardFill = function SvgCreditCardFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "credit_card_fill_svg__a",
    width: 23,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h23v23H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#credit_card_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M4.12 18.688q-.727 0-1.23-.504a1.67 1.67 0 0 1-.503-1.229V6.045q0-.726.503-1.23a1.67 1.67 0 0 1 1.23-.503h14.743q.726 0 1.229.504.503.503.503 1.229v10.91q0 .726-.503 1.23a1.67 1.67 0 0 1-1.23.503zm-.296-7.575h15.333v-3.06H3.824z"
  }))));
};
export default SvgCreditCardFill;